import { render, staticRenderFns } from "./ExecutionPlan.vue?vue&type=template&id=65c4e716&scoped=true&"
import script from "./ExecutionPlan.vue?vue&type=script&lang=js&"
export * from "./ExecutionPlan.vue?vue&type=script&lang=js&"
import style0 from "./ExecutionPlan.vue?vue&type=style&index=0&id=65c4e716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4e716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
